module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hook"
  }, [_c('div', {
    staticClass: "pull-left play"
  }, [(!_vm.isPlaying) ? _c('i', {
    staticClass: "fa fa-fw fa-play",
    on: {
      "click": _vm.handlePlay
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPlaying) ? _c('i', {
    staticClass: "fa fa-fw fa-stop",
    on: {
      "click": _vm.handleStop
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.hook.title))]), _vm._v(" "), _c('div', {
    staticClass: "artist"
  }, [_vm._v(_vm._s(_vm.hook.artist))])]), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    staticClass: "duration pull-right"
  }, [_vm._v(_vm._s(_vm.duration))]) : _c('div', {
    staticClass: "duration time pull-right"
  }, [_vm._v(_vm._s(_vm.currentTime))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-334a6464","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/music/HookMedia.vue
// module id = 3210
// module chunks = 3